import {InvoiceList} from "./InvoiceList";
import {InvoiceEdit} from "./InvoiceEdit";
import {InvoiceCreate} from "./InvoiceCreate";

export default {
    list: InvoiceList,
    create: InvoiceCreate,
    edit: InvoiceEdit
};
